export default "__VITE_ASSET__o$2GAaZ7__"